import React from 'react' 
import { Button, Dialog,DialogActions, DialogContent, DialogTitle, Typography ,IconButton} from '../ui/core';
import List from './list';
import {Close} from '../ui/coreIcons'
export default function QuickSearch({title,items,onClick,onClose}) {
 
    return (
        <Dialog onClose={onClose} fullScreen={true}>
            <DialogTitle><Typography component="h2">{title || 'Zoeken vragenlijst'}</Typography>
            {onClose && <IconButton onClick={onClose} style={{position:'absolute', right:'64px', top:'10px'}}><Close/></IconButton>}
            </DialogTitle>
            <DialogContent>
                <List items={items} onClick={onClick}/>
            </DialogContent>
            <DialogActions>
                 <Button onClick={onClose} style={{backgroundColor:'#ff6A13'}}>SLUITEN</Button>
            </DialogActions>
        </Dialog>
    )
}
